import React from "react";
import SelectField from "./SelectField";

export default function SelectService({ options, ...field }) {
  return <SelectField {...field} options={options} />;
}
